import { Component } from 'react';

/** Decode the role from the JWT in localStorage (no verification — display only). */
function getRoleFromToken() {
  try {
    const token = localStorage.getItem('token');
    if (!token || token.split('.').length !== 3) return null;
    const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    return payload?.role || null;
  } catch {
    return null;
  }
}

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, componentStack: '' };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('App Error:', error, errorInfo);
    this.setState({ componentStack: errorInfo?.componentStack || '' });
  }

  handleReportBug = () => {
    const { error, componentStack } = this.state;
    const report = {
      message: error?.message || 'Unbekannter Fehler',
      stack: (error?.stack || '').slice(0, 4000),
      componentStack: (componentStack || '').slice(0, 4000),
      url: window.location.href,
      time: new Date().toISOString(),
    };
    try {
      sessionStorage.setItem('surplify_crash_report', JSON.stringify(report));
    } catch { /* storage may be unavailable */ }
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      const { error, componentStack } = this.state;
      const role = getRoleFromToken();
      const isAdminUser = role === 'admin' || role === 'group_admin';

      return (
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f8f9fa', fontFamily: 'system-ui, sans-serif', padding: '1.5rem' }}>
          <div style={{ textAlign: 'center', padding: '2rem', maxWidth: isAdminUser ? '760px' : '500px', width: '100%' }} data-testid="error-boundary">
            <h1 style={{ fontSize: '1.5rem', fontWeight: 600, marginBottom: '1rem', color: '#1a1a1a' }}>Etwas ist schiefgelaufen</h1>
            <p style={{ color: '#666', marginBottom: '1.5rem' }}>
              {error?.message || 'Ein unerwarteter Fehler ist aufgetreten.'}
            </p>

            {isAdminUser && (
              <details
                open
                style={{ textAlign: 'left', background: '#1e1e2e', color: '#e2e8f0', borderRadius: '10px', padding: '1rem 1.25rem', marginBottom: '1.5rem', overflow: 'auto', maxHeight: '320px' }}
                data-testid="error-boundary-details"
              >
                <summary style={{ cursor: 'pointer', fontWeight: 600, color: '#fbbf24', marginBottom: '0.75rem' }}>
                  Technische Details (nur für Admins sichtbar)
                </summary>
                <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', fontSize: '0.75rem', lineHeight: 1.5, margin: 0, fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace' }}>
{error?.stack || error?.message || 'Kein Stacktrace verfügbar.'}
{componentStack ? `\n\nKomponenten-Stack:${componentStack}` : ''}
                </pre>
              </details>
            )}

            <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center', flexWrap: 'wrap' }}>
              <button
                onClick={() => window.location.reload()}
                style={{ padding: '0.75rem 1.5rem', background: '#f97316', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '0.875rem', fontWeight: 500 }}
                data-testid="error-boundary-reload-btn"
              >
                Seite neu laden
              </button>
              {isAdminUser && (
                <button
                  onClick={this.handleReportBug}
                  style={{ padding: '0.75rem 1.5rem', background: 'transparent', color: '#f97316', border: '1.5px solid #f97316', borderRadius: '8px', cursor: 'pointer', fontSize: '0.875rem', fontWeight: 600 }}
                  data-testid="error-boundary-report-btn"
                >
                  Bug melden
                </button>
              )}
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
